











































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import { CompanyStatusModel, FileDownloadModel } from "@/core/models";
import { CompanyService, QuestionnaireService } from "@/core/services";
import UpdateFollowupStatusDialogCpt from "./UpdateFollowupStatusDialogCpt.vue";
import CompleteRevisionDialogCpt from "./CompleteRevisionDialogCpt.vue";
import { RevStatusCpt, FollowUpStatusCpt } from "./status-badges";

import AppVue from "@/AppVue.vue";

@Component({
  components: {
    UpdateFollowupStatusDialogCpt,
    CompleteRevisionDialogCpt,
    RevStatusCpt,
    FollowUpStatusCpt,
  },
})
export default class WorkshopClientRevGridCpt extends AppVue {
  @Prop() companyId: number;

  model = {} as CompanyStatusModel;
  loading = false;
  showFollowupStatusDialog = false;
  showCompleteDialog = false;
  currentQuestionnaireId = 0;

  async created() {
    this.initializeModel();
  }

  private async downloadCriticalSkillsReport(id: number) {
    this.loading = true;
    try {
      const response: FileDownloadModel = await QuestionnaireService.downloadCriticalSkillsReport(id);
      await QuestionnaireService.generateCriticalSkillsFile(response);
    } finally {
      this.loading = false;
    }
  }
  private close(saved: boolean) {
    this.showFollowupStatusDialog = false;
    this.showCompleteDialog = false;
    if (saved === true) {
      this.initializeModel();
    }
  }

  private complete(questionnaireId: number) {
    this.currentQuestionnaireId = questionnaireId;
    this.showCompleteDialog = true;
  }

  private updateFollowUpStatus() {
    this.showFollowupStatusDialog = true;
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await CompanyService.getStatusById(this.companyId);
    } finally {
      this.loading = false;
    }
  }
}
